import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useToggle } from '../../../../components';
import { toggleEmailAnalyzer } from '../../../../store/auth/auth.actions';
import { RootState } from '../../../../store/store';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';

type ToggleProps = {
  defaultActive?: boolean;
  className?: string;
  serviceName: string;
  disabled?: boolean;
  appName?: string;
};

export const Toggle: React.FC<ToggleProps> = ({
  defaultActive = false,
  className = '',
  serviceName,
  disabled = false,
  appName,
}: ToggleProps): JSX.Element => {
  const { open, toggle } = useToggle(defaultActive);
  const [showConfirm, setShowConfirm] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const handleModal = () => {
    setShowConfirm(!showConfirm);
  };

  const handleConfirm = () => {
    toggle();
    setShowConfirm(false);
    dispatch(toggleEmailAnalyzer(!open, appName || '', user?.orgId || ''));
  };

  return (
    <>
      <ConfirmationModal
        onConfirm={handleConfirm}
        onClose={handleModal}
        serviceName={serviceName}
        incomingOperation={open ? 'OFF' : 'ON'}
        open={showConfirm && !disabled}
      />
      <label
        className={`toggle toggle-${
          open && !disabled ? 'active' : 'inactive'
        } ${className}`}
      >
        <input
          readOnly
          checked={open}
          className="toggle__control"
          type="checkbox"
          onClick={handleModal}
        />
        <div className="toggle__toggle" />
        <span
          className={`toggle__label toggle__label-${
            open && !disabled ? 'active' : 'inactive'
          }`}
        >
          {open && !disabled ? 'ON' : 'OFF'}
        </span>
      </label>
    </>
  );
};
